import axios from 'axios'
import { isMobile } from 'react-device-detect'
const clientId = process.env.REACT_APP_CLIENT_ID
export const getAccessToken = (): string | null => {
  return JSON.parse(localStorage.getItem('accessToken') || 'null')
}

export const accessToken = getAccessToken()

/** 토큰 필요없이 조회할 때 */
export const client = axios.create({
  baseURL: 'https://shop-api.e-ncp.com',
  headers: {
    version: '1.0',
    clientid: clientId,
    platform: isMobile ? 'MOBILE_WEB' : 'PC',
  },
  responseType: 'json',
})

/** 회원 토큰 필요할 때 사용 */
export const userClient = axios.create({
  baseURL: 'https://shop-api.e-ncp.com',
  headers: {
    version: '1.0',
    clientid: clientId,
    platform: isMobile ? 'MOBILE_WEB' : 'PC',
  },
  responseType: 'json',
})

/** 비회원 토큰 필요할 때 사용 */
export const guestClient = axios.create({
  baseURL: 'https://shop-api.e-ncp.com',
  headers: {
    version: '1.0',
    clientid: clientId,
    platform: isMobile ? 'MOBILE_WEB' : 'PC',
  },
  responseType: 'json',
})

client.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken()
    if (accessToken !== null) {
      config.headers['accessToken'] = accessToken
    }
    return config
  },
  (error) => Promise.reject(error)
)

userClient.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken()
    if (accessToken !== null) {
      config.headers['accessToken'] = accessToken
    }
    return config
  },
  (error) => Promise.reject(error)
)

// // 응답 인터셉터 추가
userClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          window.localStorage.removeItem('aboutRefreshToken')
          window.localStorage.removeItem('aboutAccessToken')
          window.localStorage.removeItem('accessToken')
          window.localStorage.removeItem('lastAccessTokenUpdateTime')
          setTimeout(() => {
            window.location.reload()
          }, 300)

          break
        default:
          break
      }
    } else {
      console.error('네트워크 오류 또는 기타 예외 발생')
    }
    return Promise.reject(error)
  }
)

/** 비회원 주문 패스워드 초기화 */
export async function getGuestForgotPassword(orderNo: string, mobileNo: string) {
  return await client.get(`/guest/orders/${orderNo}/forgot-password?replyType=SMS&mobileNo=${mobileNo}`)
}

/** 내 등급 조회하기 */
export async function getGrade() {
  return await userClient.get(`/profile/grade`)
}

/** 회원조회 */
export async function getProfile() {
  return await userClient.get(`/profile`)
}

export async function getProfileHeader(accessToken: string) {
  return await userClient.get(`/profile`, {
    headers: {
      accessToken: accessToken,
    },
  })
}

export async function postOpenid(accessToken: string) {
  return await client.post(`/oauth/openid`, {
    provider: 'ncpstore',
    code: null,
    openAccessToken: accessToken,
    redirectUri: null,
    state: null,
    keepLogin: false,
  })
}
